import { TableGridCell } from 'components/DataTable/TableGrid/Cells'
import moment from 'moment'
import { dateFormat } from 'utils/constants'

export const ImportsDateCell = ({ rowData }) => (
  <TableGridCell>{moment(rowData.created_at).format(dateFormat)}</TableGridCell>
)
